import { useState } from "react";
import { EnergyLabelDrawer } from "./components/EnergyLabelDrawer/EnergyLabelDrawer";
import { dispatchMonetateQEvent } from "@/utils/monetate/monetateQ";
import { EnergyLabelCTA } from "@/components/EnergyLabel/components/EnergyLabelCTA/EnergyLabelCTA.tsx";

export type EnergyLabelUIProps = {
  /**
   * An optional string representing the information sheet.
   */
  informationSheet?: string;
  /**
   * A boolean indicating whether the energy label is legacy.
   */
  isLegacy: boolean;
  /**
   * An optional string representing the label.
   */
  label?: string;
  /**
   * A string representing the rating.
   */
  rating: string;
  /**
   * An optional string representing the open drawer event.
   */
  openDrawerEvent?: string;
  /**
   * An optional string representing the close drawer event.
   */
  closeDrawerEvent?: string;
  /**
   * An optional string representing the close drawer event.
   */
  energyComboMode?: boolean;
};

const availableRating = ["A", "B", "C", "D", "E", "F", "G"];
const availableRatingLegacy = ["A+++", "A++", "A+", "A", "B", "C", "D"];

export const EnergyLabelUI = ({
  label,
  rating,
  informationSheet,
  isLegacy,
  openDrawerEvent,
  closeDrawerEvent,
  energyComboMode = false,
}: EnergyLabelUIProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenDrawer = () => {
    if (openDrawerEvent) {
      dispatchMonetateQEvent(openDrawerEvent);
    }

    setIsOpen(true);
  };

  const handleCloseDrawer = () => {
    if (closeDrawerEvent) {
      dispatchMonetateQEvent(closeDrawerEvent);
    }

    setIsOpen(false);
  };

  const isEnergyRatingValid =
    (isLegacy && availableRatingLegacy.includes(rating)) ||
    (!isLegacy && availableRating.includes(rating));

  if (!rating || !isEnergyRatingValid) {
    return null;
  }

  const hasAdditionalSheets = !!label || !!informationSheet;

  return (
    <>
      <EnergyLabelCTA
        rating={rating}
        isLegacy={isLegacy}
        handleClick={hasAdditionalSheets ? handleOpenDrawer : undefined}
        dataComponent="EnergyLabel"
        energyComboMode={energyComboMode}
      />
      {hasAdditionalSheets && (
        <EnergyLabelDrawer
          isOpen={isOpen}
          isLegacy={isLegacy}
          handleClose={handleCloseDrawer}
          rating={rating}
          label={label}
          informationSheet={informationSheet}
        />
      )}
    </>
  );
};
